import { render, staticRenderFns, recyclableRender, components } from "./my-bargain.vue?vue&type=template&id=366acf44&"
var renderjs
import script from "./my-bargain.vue?vue&type=script&lang=js&"
export * from "./my-bargain.vue?vue&type=script&lang=js&"
import style0 from "./my-bargain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!E:\\HBuilderX\\plugins\\uniapp-cli\\node_modules\\@dcloudio\\vue-cli-plugin-uni\\packages\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/user/my-bargain/my-bargain.vue"
export default component.exports